import { createWithEqualityFn as create } from "zustand/traditional";
import { AppSlice, createAppSlice } from "./slices/app-slice";
import { createPassportSlice, PassportSlice } from "./slices/passport-slice";
import { createPopupSlice, PopupSlice } from "./slices/popup-slice";
import { createSessionSlice, SessionSlice } from "./slices/session-slice";

export type SlicedStore = AppSlice & PopupSlice & SessionSlice & PassportSlice;

export const useAppStore = create<SlicedStore>()((...a) => ({
  ...createAppSlice(...a),
  ...createPopupSlice(...a),
  ...createSessionSlice(...a),
  ...createPassportSlice(...a),
}));
